import React from "react"

import { Action } from "shared/types/Action"
import { ProductPosition } from "shared/types/ProductPosition"
import { ProductInformation } from "shared/types/__generated__/graphql"
import { RowRendererProps } from "shared/ui/table/types"

import { ProductPositionTableProductPositionRowView } from "./ProductPositionTableProductPositionRowView"
import { useProductPositionTableProductPositionRowViewModel } from "./hooks/useProductPositionTableProductPositionRowViewModel"

export interface EnhancedProductPositionTableRowPayload {
  title?: string | null
  productType?: string | null
  isTitleLoading?: boolean
  isValid?: boolean
  isLoadingValidity?: boolean
  productInformation?: ProductInformation | null | undefined
  isPending?: boolean
  actions?: Action[]
}

export interface ProductPositionTableProductPositionRowProps
  extends RowRendererProps<ProductPosition>,
    EnhancedProductPositionTableRowPayload {}

export function ProductPositionTableProductPositionRowComponent(
  props: ProductPositionTableProductPositionRowProps
) {
  return (
    <ProductPositionTableProductPositionRowView
      {...useProductPositionTableProductPositionRowViewModel(props)}
    />
  )
}

export const ProductPositionTableProductPositionRow = React.memo(
  ProductPositionTableProductPositionRowComponent
) as typeof ProductPositionTableProductPositionRowComponent
